define('app/sds/additionaldata/sds-additionaldata-service',["service!selcomm", "$q"], function (SelcommWS, $q) {
	var sourcePrototype = {
		update: function update(attribute) {
			return SelcommWS.put("Contact", (attribute && attribute.Information) ? "ContactAdditionalFieldDataUpdate" : "ContactAdditionalFieldDataDelete", {
				AdditionalFieldData: attribute
			});
		},
		displayTextExpr: "$attribute.AdditionalField.LabelNarrative",
		selectValuesExpr: "$attribute.AdditionalField.PossibleValues",
		stringTypeExpr: "$attribute.AdditionalField.StringTypeCode",
		valueExpr: "$attribute.Information"
	};
	return function sdsAdditionalData(contactCode) {
		var source = Object.create(sourcePrototype);
		return SelcommWS.get("Contact", "ContactAdditionalFieldDataList", {
			ContactCode: contactCode || SelcommWS.authentication.currentSession.CurrentContactCode
		}).then(function (contAddInfoList) {
			source.items = (contAddInfoList = (contAddInfoList && contAddInfoList.Items || contAddInfoList));
			return $q.all(angular.map(contAddInfoList, function (contAddInfo) {
				return SelcommWS.get("Validation", "StringTypePossibleValues", {
					StringTypeCode: contAddInfo.AdditionalField.StringTypeCode
				}).then(function SuccessResult(values) {
					var valFuzzy, fuzzyValueFix;
					if (values) {
						contAddInfo.AdditionalField.PossibleValues = values;
						// Fix the case where whitespace padding causes drop-downs to not select the value.
						if (contAddInfo.Information && values.indexOf(contAddInfo) < 0) {
							valFuzzy = angular.isString(contAddInfo.Information) ? contAddInfo.Information.trim() : contAddInfo.Information;
							fuzzyValueFix = angular.filter(values, function (keyValuePair) {
								var keyFuzzy = angular.isString(keyValuePair.Key) ? keyValuePair.Key.trim() : keyValuePair.Key;
								return keyFuzzy == valFuzzy;
							});
							if (fuzzyValueFix.length === 1) {
								contAddInfo.Information = fuzzyValueFix[0].Key;
							}
						}
						contAddInfo.type = "select";
					}
					else {
						contAddInfo.type = "string";
					}
				});
			}));
		}).then(function () {
			return source;
		});
	};
});
